import { PayloadAction } from '@reduxjs/toolkit';
import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import ApprovalGateway from '~apis/approval';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TUpdateProjectStatusReduxParams } from '~types/feat/approval';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { ProjectChangeHistoryStatusEnum, TransactionStatusEnum } from '~utils/enums';

export default function* watchUpdateProjectStatus(api: ApprovalGateway): SagaWatcherReturnType {
    yield takeEvery('approval/approvalUpdateProjectStatusAttempt', handleUpdateProjectStatus, api);
}

function* handleUpdateProjectStatus(api: ApprovalGateway, data: PayloadAction<TUpdateProjectStatusReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        id,
        status,
    } = data.payload;

    const response = yield* call([api, api.updateProjectStatus], {
        authToken,
        id,
        status,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.approvalUpdateProjectStatusFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        const successMessage = status === ProjectChangeHistoryStatusEnum.Approved
            ? SuccessMessages.ApprovalApproveProjectSuccess
            : status === ProjectChangeHistoryStatusEnum.Rejected
                ? SuccessMessages.ApprovalRejectProjectSuccess
                : '';

        yield put(combinedActions.approvalSetConfirmUpdateProjectStatusModalIsOpen(false));
        yield put(combinedActions.approvalGetPendingProjectListingAttempt());
        yield put(combinedActions.approvalUpdateProjectStatusSuccess());

        toast.success(successMessage);
    }
}
